<template>
  <y-block-box title="用户增量">
    <template #suffix>
      <btn-change-group :items="btnItems" v-model="selectedBtn"></btn-change-group>
    </template>
    <div v-loading="fullLoading" style="display: flex;height: 100%;overflow: auto;">
      <y-spacer>
        <div v-loading="chartLoading" style="width: 100%;height: 100%;overflow: auto;">
          <LineChart
            :xAxisData="xAxisData"
            :seriesData="seriesData"
            seriesName="用户增量"
          />
        </div>
      </y-spacer>
      <!-- 右侧大数字统计图 -->
      <div class="flex-column" style="height: 100%;">
        <shadow-num-card
          icon="el-icon-user-solid"
          title="用户统计"
          :value="count.all"/>
        <shadow-num-card
          icon="el-icon-date"
          icon-color="#00B5FF"
          title="近一个月"
          :value="count.month"/>
        <shadow-num-card
          icon="el-icon-s-flag"
          icon-color="#FFB600"
          title="最近一周"
          :value="count.week"/>
      </div>
    </div>
  </y-block-box>
</template>

<script>
import ShadowNumCard from "@/components/common/ShadowNumCard.vue";
import LineChart from "@/components/common/LineChart.vue";

export default {
  name: "UserGrowth",
  components: {LineChart, ShadowNumCard},
  data(){
    return{
      btnItems:[
        {text:'年',value:'year'},
        {text:'月',value:'month'},
        {text:'周',value:'week'},
        {text:'日',value:'day'},
      ],
      count:{
        all:0,
        week:0,
        month:0,
      },
      xAxisData:[],
      seriesData:[],
      selectedBtn:'month',
      fullLoading:false,
      chartLoading:false,
    }
  },
  mounted(){
    this.fnQuery();
  },
  watch:{
    selectedBtn: {
      async handler(){
        this.chartLoading = true;
        await this.queryHistory();
        this.chartLoading = false;
      }
    }
  },
  methods:{
    async queryHistory() {
      const resData = await this.$callApi(
        "board.getUserCountHistory",
        {unit: this.selectedBtn, begin: 0, end: -999, step: -1}
      )
      this.xAxisData = resData.data.map((item)=>{
        let date = new Date(item._id);
        return date.getFullYear() + "-" + (date.getMonth() + 1)+"-" + date.getDate();
      })
      this.seriesData = resData.data.map((item)=>{
        return item.count;
      })
    },
    async queryCount() {
      const resData = await this.$callApi("board.getUserCount", {unit: this.selectedBtn})
      this.count = resData.data;
    },
    async fnQuery() {
      this.fullLoading = true;

      try {
        await Promise.all([
          this.queryHistory(),
          this.queryCount(),
        ]);
      } catch (e) {
        console.error("fnQuery 发生错误:", e);
      } finally {
        this.fullLoading = false;
      }
    }
  }
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/board/components/UserGrowth/UserGrowth.vue